export const ASSETS = {
  BTC: "Bitcoin",
  ETH: "Ethereum",
  AAPL: "Apple",
  USD: "US Dollar",
  AAVE: "AAVE",
  DAI: "Dai",
  TSLA: "Tesla",
  UNI: "Uniswap",
  EUR: "Euro",
  EURO: "Euro",
};
